import React from "react";
import styled from "styled-components";
import { T } from "../../theme";
import { PROCESS } from "../../data/careers";
import Reveal from "../Reveal";
import { Band, Shell, Eyebrow, Heading, Lead, Head } from "./ui";

const Track = styled.ol`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0;
  position: relative;

  /* linha conectora */
  &::before {
    content: "";
    position: absolute;
    top: 22px;
    left: 8%;
    right: 8%;
    height: 2px;
    background: linear-gradient(90deg, var(--purple), color-mix(in srgb, var(--purple) 20%, transparent));
    z-index: 0;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 4px;
    &::before {
      top: 0; bottom: 0; left: 21px; right: auto;
      width: 2px; height: auto;
    }
  }
`;

const Step = styled.li`
  position: relative;
  z-index: 1;
  padding: 0 12px;
  text-align: center;

  @media (max-width: 760px) {
    text-align: left;
    display: grid;
    grid-template-columns: 44px 1fr;
    gap: 14px;
    align-items: start;
    padding: 12px 0;
  }
`;

const Dot = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.86rem;
  font-weight: 800;
  color: #fff;
  background: linear-gradient(135deg, #9b51ff, #7c3aed);
  box-shadow: 0 4px 16px rgba(124, 58, 237, 0.4);
  border: 3px solid ${T.bg};

  @media (max-width: 760px) { margin: 0; }
`;

const STitle = styled.h3`
  font-size: 0.94rem;
  font-weight: 800;
  color: ${T.text};
  margin-bottom: 6px;
  letter-spacing: -0.01em;
`;

const SDesc = styled.p`
  font-size: 0.79rem;
  color: ${T.muted};
  line-height: 1.55;
  margin-bottom: 10px;
`;

const Meta = styled.span`
  display: inline-block;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--purple);
  background: var(--purple-soft);
  border: 1px solid color-mix(in srgb, var(--purple) 24%, transparent);
  padding: 3px 9px;
  border-radius: 999px;
`;

export default function Process() {
  return (
    <Band id="processo" $soft $top $bottom aria-labelledby="proc-title">
      <Shell>
        <Reveal>
          <Head>
            <Eyebrow>Como funciona</Eyebrow>
            <Heading id="proc-title">Um processo justo, rápido e sem pegadinha.</Heading>
            <Lead>
              Respeitamos o seu tempo. Cinco etapas claras, feedback em cada uma e
              compromisso de primeira resposta em até 5 dias úteis.
            </Lead>
          </Head>
        </Reveal>

        <Reveal>
          <Track>
            {PROCESS.map((p) => (
              <Step key={p.step}>
                <Dot aria-hidden="true">{p.step}</Dot>
                <div>
                  <STitle>{p.title}</STitle>
                  <SDesc>{p.desc}</SDesc>
                  <Meta>{p.meta}</Meta>
                </div>
              </Step>
            ))}
          </Track>
        </Reveal>
      </Shell>
    </Band>
  );
}
